// Zentrale Logik für ausländische USt-Sätze (Single Source of Truth).
// Inländische Sätze je Land — alles andere (>0, nicht im Set, kein RC/i.g. Erwerb)
// gilt als ausländischer Satz und ist nicht über die inländische UVA als Vorsteuer
// abziehbar (Brutto = Betriebsausgabe; ggf. EU-Vorsteuererstattungsverfahren).
export const DOMESTIC_VAT_RATES = {
  DE: [0, 7, 19],
  AT: [0, 4.9, 10, 13, 20],
  CH: [0, 2.6, 3.8, 8.1],
};

/**
 * Liefert die ausländischen USt-Sätze eines Belegs/Datensatzes.
 * @param {object} source - Beleg/Ausgabe/extrahierte Daten mit vat_rate,
 *   tax_breakdown[], is_reverse_charge, is_intra_community_acquisition.
 * @param {string} country - Land des Steuerpflichtigen (DE/AT/CH).
 * @returns {number[]} eindeutige ausländische Sätze (>0), sonst [].
 */
export function getForeignRates(source, country) {
  if (!source) return [];
  if (source.is_reverse_charge || source.is_intra_community_acquisition) return [];
  const domestic = DOMESTIC_VAT_RATES[(country || 'DE').toUpperCase()] || DOMESTIC_VAT_RATES.DE;
  const rates = Array.isArray(source.tax_breakdown) && source.tax_breakdown.length
    ? source.tax_breakdown.map((t) => Number(t.rate)).filter((r) => r > 0)
    : (Number(source.vat_rate) > 0 ? [Number(source.vat_rate)] : []);
  return [...new Set(rates.filter((r) => !domestic.includes(r)))];
}
